import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config.js';

const APP_VERSION = require('../../package.json').version;
const API_URL = API_BASE_URL;

export const useVersionCheck = () => {
  const [versionStatus, setVersionStatus] = useState(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    checkVersion();

    // Listen for app coming back from background (visibilitychange)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log('📱 App focused - rechecking version...');
        checkVersion();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const checkVersion = async () => {
    try {
      const response = await fetch(
        `${API_URL}/api/version/check?app_version=${APP_VERSION}`,
        { method: 'GET', signal: AbortSignal.timeout(8000) }
      );
      if (!response.ok) throw new Error('Server error');
      const data = await response.json();
      setVersionStatus(data);
      setIsChecking(false);
    } catch (error) {
      console.warn('⚠️ Version check failed:', error.message);
      let bypassAllowed = true;
      setVersionStatus({
        can_run: bypassAllowed,
        update_mode: bypassAllowed ? 'none' : 'blocked',
        offline_mode: true,
        message: bypassAllowed ? null : 'Không thể kết nối máy chủ. Vui lòng kiểm tra kết nối internet.'
      });
      setIsChecking(false);
    }
  };

  return { versionStatus, isChecking, recheckVersion: checkVersion };
};